import { graphql } from "@opensea/graphql"
import { ActivityFeedLiveTimestampFragment } from "@/components/activity-feed/ActivityFeedLiveTimestamp.fragment"
import { ActivityFromFragment } from "@/components/activity-feed/ActivityFrom.fragment"
import { ActivityPriceFragment } from "@/components/activity-feed/ActivityPrice.fragment"
import { ItemAvatarFragment } from "@/components/items/avatar/ItemAvatar"
import { ItemLinkFragment } from "@/components/items/ItemLink/ItemLink.fragment"
import { ItemPreviewTooltipFragment } from "@/components/items/ItemPreviewTooltip/ItemPreviewTooltip.fragment"

export const SalesFeedTableRowFragment = graphql(
  `
    fragment SalesFeedTableRow on Activity {
      id
      ... on Sale {
        ...ActivityFrom
        item {
          name
          ...ItemAvatar
          ...ItemLink
          ...ItemPreviewTooltip
        }
        ...ActivityPrice
        ...ActivityFeedLiveTimestamp
      }
    }
  `,
  [
    ItemAvatarFragment,
    ActivityFeedLiveTimestampFragment,
    ActivityPriceFragment,
    ActivityFromFragment,
    ItemLinkFragment,
    ItemPreviewTooltipFragment,
  ],
)
